export default "__VITE_ASSET__KGKTEbAO__"